import React from 'react';
import Spin from 'antd/es/spin';
import styles from './Loader.module.scss';
import 'antd/es/spin/style';

function Loader({ size }) {
  return (
    <Spin className={styles.spinner} size={size} />
  );
}

export default Loader;
